import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from 'src/shared/material/material.module';
import { CommonModule } from '@angular/common';
import { OptionalJobFieldsToShowComponent } from './optional-job-fields-to-show/optional-job-fields-to-show.component';
import { OptionalJobFieldsComponent } from './optional-job-fields/optional-job-fields.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MaterialModule,
		FlexLayoutModule,
	],
	declarations: [
		OptionalJobFieldsComponent,
		OptionalJobFieldsToShowComponent,
	],
	exports: [OptionalJobFieldsComponent, OptionalJobFieldsToShowComponent],
})
export class OptionalJobFieldsModule {}
